const Globals = {
    convertLocaleForMoments: (locale = 'en') => {
        if (locale === 'mx') {
            locale = 'es';
        }

        return locale;
    },

    fetchVehiclesOnCurrencyChange: (quoteId, quote, store, booking = null) => {
        const currentCurrency = quote.converted_currency;
        if (quoteId) {
            store.dispatch('fetchQuote', quoteId)
                .then((response) => {
                    if (booking) {
                        store.dispatch('fetchBooking', booking)
                          .catch(error => console.log(error));
                    }
                });
            store.dispatch('fetchVehicles', { quoteId: quoteId, sortDriveAndGo: '&sort_drive_and_go' });

            if (quote.selected_vehicle && quote.selected_vehicle.data.id) {
                store.dispatch('fetchVehicleInsuranceOptions', {
                    quoteId: quoteId,
                    vehicleId: quote.selected_vehicle.data.vehicle.data.id,
                });
                store.dispatch('fetchExtras', quoteId);
            }
        }
    },

    fetchBookingOnCurrencyChange: (bookingId,  store) => {
        store.dispatch('fetchBooking', bookingId);
    },

    getQuoteInfo: (quote) => {
        window.greenmotion.quoteInfo = {
            display_currency: quote?.converted_currency,
            duration: quote?.hire_duration_in_days,
            currency: quote?.currency,
            location: {
                id: quote?.pickup_location?.data?.id,
                name: quote?.pickup_location?.data?.name,
                slug: quote?.pickup_location?.data?.slug,
                city: quote?.pickup_location?.data?.city,
                country: {
                    name: quote?.pickup_location?.data?.country?.data?.name,
                    slug: quote?.pickup_location?.data?.country?.data?.slug,
                },
            },
            payment_type: quote?.payment_type,
            selected_vehicle: {
                id: quote?.selected_vehicle?.data?.id,
                total: quote?.selected_vehicle?.data?.total,
            },
            totals: {
                total_gbp: quote?.totals?.data?.binding_pay_online_gbp,
                total_selected_currency: quote?.totals?.data?.pay_online_with_donation,
            }
        };
    },

    isPPAndPOAJourney(quote) {
        return !quote?.is_poa_only && quote?.pay_on_arrival_available;
    },

    isUsaveBrand() {
        return window.brand === 'usave';
    },

    isUsavePPAndPoaJourney(quote) {
        return this.isUsaveBrand() && this.isPPAndPOAJourney(quote);
    },

    payNowSavingText(totals, trans) {
        var poa = totals.pay_on_arrival;
        var pp  = totals.pay_online_with_donation;

        // Calculate the percentage savings
        var percent = ((poa - pp) / poa) * 100;

        if (percent > 0.00 && percent < 1.00) {
          return trans("booking-process.shared.save_by_paying_now_label");
        }

        // Only show the message if the online price is lower than the pay on arrival price
        if (pp < poa) {
          return trans("booking-process.shared.pay_now_and_save_label") + ` ${ percent.toFixed(0) }%`;
        }

        // Return empty string if no savings
        return '';
    },

    poaTotal(totals) {
        return totals.pay_on_arrival;
    },
}

export default Globals;